import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AdminDistrict {
  id: number | null
  name: string | null
  nickname: string | null
  subscriptionType: string | null
  subscriptionStatus: string | null
  subscriptionRenewalDate: string | null
  csmName: string | null
  csmEmail: string | null
  csmPhoneNumber: string | null
}

export const selectDistricts = (state: any): AdminDistrict[] => state.districts
export const selectDistrictByName = (name: string) => (state: any): AdminDistrict => state.districts.find((district: AdminDistrict) => district.name === name)
export const selectDistrictById = (id: number) => (state: any) => state.districts.find((district: AdminDistrict) => district.id === id)

const initialState: AdminDistrict[] = [{
  id: null,
  name: null,
  nickname: null,
  subscriptionType: null,
  subscriptionStatus: null,
  subscriptionRenewalDate: null,
  csmName: null,
  csmEmail: null,
  csmPhoneNumber: null,
}]

const districtsSlice = createSlice({
  name: 'districts',
  initialState,
  reducers: {
    loadDistricts: (state, {
      payload: districts,
    }: PayloadAction<any[]>) => districts.map((district: any) => ({
      id: district.id,
      name: district.name,
      nickname: district.nickname,
      subscriptionType: district.subscriptionType,
      subscriptionStatus: district.subscriptionStatus,
      subscriptionRenewalDate: district.subscriptionRenewalDate,
      csmName: district.csmName,
      csmEmail: district.csmEmail,
      csmPhoneNumber: district.csmPhoneNumber,
    })),
    addDistrict: (state, {
      payload: district
    }: PayloadAction<AdminDistrict>) => {
      const index = state.findIndex((d) => d.id === district.id)
      if (index !== -1) {
        state[index] = district
      } else {
        state.push(district)
      }
    }
  },
})

export const { loadDistricts, addDistrict } = districtsSlice.actions

export default districtsSlice.reducer
